/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum OpenUrlWithKind {
  IFrame = 'IFrame',
  SameTab = 'SameTab',
  NewTab = 'NewTab'
}
